import {createContext,useContext} from 'react';
import type {DraftLayout} from '../../lib/scriptDraftLayout';
export const ScriptDraftContext=createContext<DraftLayout|undefined>(undefined);
export const useDraftBlock=(id:string)=>useContext(ScriptDraftContext)?.blocks.get(id);
